import { render } from "./CMSPage.vue?vue&type=template&id=51aee453&scoped=true"
import script from "./CMSPage.vue?vue&type=script&lang=js"
export * from "./CMSPage.vue?vue&type=script&lang=js"

import "./CMSPage.vue?vue&type=style&index=0&id=51aee453&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51aee453"]])

export default __exports__